<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px">
                    <el-row>
                        <el-col :span="16">
                        <el-form-item label="엑셀파일">
                            <el-col :span="14">
                            <el-input type="text" v-model="file.name" readonly/>
                            <input ref="file" type="file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="fileChangeEvent" hidden/>
                            </el-col>
                            <el-col :span="8">
                            <el-button type="primary" size="mini" icon="el-icon-files" @click="uploadArea">
                                {{fileLoaded ? '파일찾기' : '신규 업로드'}}
                            </el-button>
                            </el-col>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4">
                        <el-button type="danger" size="mini" icon="el-icon-upload2" @click="uploadFile">
                            업로드
                        </el-button>
                        </el-col>
                        <el-col :span="4">
                        <el-button size="mini" type="primary" icon="el-icon-document-add" @click="save">
                            저장
                        </el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                        <el-form-item label="샘플양식">
                            <el-button size="mini" type="success" icon="el-icon-document-checked" @click="tempDownload(groupNm)">
                            양식 다운
                            </el-button>
                        </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- <el-form size="mini" label-width="65px">
                    <el-row :gutter="20">
                        <el-col :span="18">
                            <el-form-item label="엑셀파일">
                            <button type="button" class="btn-size btn-blue fl_left" @click="showEnableUploadArea">
                                <span class="btn-icon"><i class="fas fa-upload"></i></span>
                                신규 업로드
                            </button>
                            
                            <div class="table-area mt20" v-if="enableUploadArea">
                                <div class="table-b">
                                    <div class="table-header">
                                        <div class="table-name">
                                            <h3 class="ico_table_name">업로드 파일 선택</h3>
                                        </div>
                                    </div>
                                    <div class="upload-area">
                                        <div class="input-area">
                                            <input type="text" class="input" v-model="file.name" readonly="readonly"/>
                                            <input ref="file" type="file" v-show="false" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="fileChangeEvent"/>
                                        </div>
                                        <div class="btn-wrap btn-type1">
                                            <button type="button" class="btn-size btn-gray fl_left" @click="searchFile">
                                                파일찾기
                                            </button>
                                            <button type="button" class="btn-size btn-blue fl_left" @click="uploadFile">
                                                업로드
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            </el-form-item>
                        </el-col>
                         
                        <el-col :span="6">
                            <div class="btn-type1">
                                <el-button size="mini" type="primary" icon="el-icon-search" @click="save">
                                    저장
                                </el-button>
                                <el-button size="mini" type="success" icon="el-icon-document-checked" @click="tempDownload(groupNm)">
                                  양식 다운
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form> -->
            </div>

            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady"
                        />
                </div>
            </div>

          <div class="table-area" v-show='false'>
            <div class="table-b">
              <ag-grid-vue
                style="width: 100%; height: 320px;"
                class="ag-theme-alpine"
                row-selection="single"

                :column-defs="columnDefsTemp"
                :grid-options="gridOptionsTemp"
                :row-data="tempFormData"
                :default-col-def="defaultColDefTemp"
              />
            </div>
          </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
      titleData: {
        Type: Array
        , required: false
      },
      groupNm: {
        Type: String
        , required: false
      },
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: '제품사양 엑셀 Upload',

            rowCount:0,
            //enableUploadArea: false,
            file: {
                name: undefined
            },
            fileLoaded: false,

            // AG-GRID OPTION [START]
            subData:[],
            tempData:[],
            tempFormData:[],
            gridOptions: {},
            gridOptionsTemp: {},
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            setupGroupId: '',

            columnDefs:[
            ],
            columnDefsTemp:[
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            defaultColDefTemp: {
              resizable: true,
              filter:true,
              sortable: true
            },
            form: {}
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}

    },
    methods: {
        // showEnableUploadArea() {
        //     this.enableUploadArea = this.enableUploadArea ? false : true
        // },
        uploadArea() {
            if(!this.fileLoaded) {
            this.$confirm('제품사양 엑셀 파일 업로드를 진행 하시겠습니까?', '파일 업로드', {
                confirmButtonText: '확인',
                cancelButtonText: '취소',
                type: 'info'
                }).then(() => {
                this.searchFile();
                }).catch(err => {
                console.log("err ", err)
                this.$message({
                    type: 'warning',
                    message: '취소되었습니다.'
                });
                })
            } else {
                this.searchFile();
            }
        },
        searchFile() {
            this.$refs.file.click()
        },
        fileChangeEvent() {
            this.file = this.$refs.file.files[0] || {
                name: undefined
            }
            this.fileLoaded = this.$refs.file.files[0] !== undefined
        },
        uploadFile() {
            if (this.fileLoaded) {
                let form = new FormData();
                form.append('file', this.file);
                const data = JSON.stringify(this.titleData); //기타 json파일
                form.append('data', data);


                this.$store.commit('loading');
                this.$http.post(`/api/productMng/excel/temp/upload`, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$swal({
                        type: 'success',
                        text: response.data
                    }).then(this.query)
                    if (response.data.length == 0){
                      this.$swal({
                        type: 'error',
                        text: '업로드 할 내용이 없습니다. 파일을 확인해주세요.'
                      });
                    }else{
                      this.$swal({
                        type: 'success',
                        text: '업로드에 성공했습니다.'
                      });
                    }
                    this.subData = response.data;
                  return response;
                }).catch(e => {
                  this.$swal({type: 'error', text: e.response.data.message});
                  return e;
                }).finally(() => {
                    //this.enableUploadArea = false;
                    this.$store.commit('finish');
                })
            } else {
                this.$swal({
                    type: 'warning',
                    text: '업로드할 파일을 선택해주세요.'
                })
            }
        },
        closeModal() {
            this.$parent.close();
        },
        onGridReady(params){
            this.columnApi = params.columnApi;
            this.columnDefs = [];
            this.columnDefsTemp = []
            this.makeColumnList(this.titleData);
            this.autoSizeAll(this.columnApi);
        },
        makeColumnList(titleData){
          for(var i = 1; 50 >= i ; i++){ // 컬럼 갯수
            let hName = eval("titleData.modelSpec"+this.StringFormat(i));
            let fName = "modelSpec"+this.StringFormat(i);
            if(hName !== "")
              this.columnDefs.push({
                headerName: hName,
                field: fName,
                width: 100,
                editable: false
              });
              this.columnDefsTemp.push({
                headerName: hName,
                field: fName,
                width: 100,
                editable: false
              });
          }
        },
        StringFormat(num){
          if(num < 10){
            num = "0"+num
          }
          return num;
        },
        autoSizeAll(columnApi) {
          const allColumnIds = [];
          columnApi.columnController.gridColumns.forEach((column) => {
            allColumnIds.push(column.getId());
          });
          columnApi.columnController.autoSizeColumns(allColumnIds, false);
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onModelGroupChange(e){
            // console.log('onModelGroupChange start====', e.target)
            // 모델이 변경시 하위 제품군 조회
        },
        selectTmpBomDataList(data){
            /** 업로드후 템프 테이블의 데이터 인설트 */
            const vform = data;
            this.$store.commit('loading')
            this.$http.post(("/api/productMng/excel/bom/upload"), vform
                ).then(response => {
                    this.subData = response.data || []
                }).finally(() => {
                    this.$store.commit('finish')
                });
        },
        tempDownload(groupNm){
          this.gridOptionsTemp.api.exportDataAsExcel({fileName: groupNm+' 양식'});
        },
        save(){

            if(this.subData.length <= 0){
                this.$swal({ type: 'warning', text: '업로드데이타가 없습니다. 신규업로드후에 저장하시기 바랍니다.' })
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `엑셀Upload를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')

                    const vform = this.subData;
                    
                    this.$http.post(_url("/api/productMng/excel/product/upload"), vform ,{timeout: 60000*100} )
                        .then(response => {
                            this.$swal({ type: 'success', text: '저장되었습니다.' });
                            this.closeModal();
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'error', text: '저장에 실패 했습니다.' });
                        })
                        .finally(() => {
                            this.$store.commit('finish');
                        });

                }
            });
 
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>